import { AddEventsAndMergeTimestamps, Timestamps } from 'Utils/ChaptersToTimestamps';
import {
  Exercise,
  Lecture,
  NoTimeExercise,
  Section,
  StaffExercise,
  Tutorial,
} from 'Utils/TutorialConfigHelper';
import timestamps from './level23.json';

const zero = '0:0';

const Level23 = Tutorial(23, zero, [
  Section([Lecture('Stretching, Squeezing, Hopping', zero)]),
  Section([
    Exercise(
      'Notes Without Skipping',
      zero,
      NoTimeExercise({ centre_align_horizontal: true, objectives: [{}, {}] }),
      [],
    ),
    Lecture('Pivoting to the Right', zero),
    Exercise(
      'Pivoting to the Right',
      zero,
      NoTimeExercise({ centre_align_horizontal: true, objectives: [{}] }),
      [],
    ),
    Lecture('Pivoting to the Left', zero),
    Exercise(
      'Pivoting to the Left',
      zero,
      NoTimeExercise({ centre_align_horizontal: true, objectives: [{}] }),
      [],
    ),
    Lecture('2nd Finger Pivot', zero),
    Exercise(
      '2nd Finger Pivot',
      zero,
      NoTimeExercise({ centre_align_horizontal: true, objectives: [{}, {}] }),
      [],
    ),
    Lecture('Switchback Pivot', zero),
    Exercise(
      'Switchback Pivot',
      zero,
      NoTimeExercise({ centre_align_horizontal: true, objectives: [{}] }),
      [],
    ),
    Exercise('Playing in Time', zero, StaffExercise({ objectives: [{}, {}] }), []),
  ]),
  Section([
    Lecture('Using Both Hands', zero),
    Exercise('Alternating Hands', zero, StaffExercise({ objectives: [{}] }), []),
    Exercise('Hands Together', zero, StaffExercise({ objectives: [{}, {}] }), []),
  ]),
]);

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level23);
